<template>
  <div class="flex h-full flex-col">
    <template v-if="value && value.length">
      <SearchResultList :value="value" show-all />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { SearchResultList, type SearchResultsObject } from '@/5_entities/Search'

type PropType = {
  value?: SearchResultsObject[]
}

withDefaults(defineProps<PropType>(), {
  value: undefined
})
</script>
